import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageBySyncCard,
} from "app/services/TreatmentPlanCardService";
import { removeCard } from "app/services/SyncCRMService";

export default class CardVoidedSyncStore {
  searchRegisterCard = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
    voided: true
  };
  selectCardSync = [];
  resetSelectedRows = false;

  pageRegisterCard = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterCard = async () => {
    let { orderDate, ...ortherData } = this.searchRegisterCard;
    return await searchByPageBySyncCard({
      ...ortherData,
      getStaffRevenues: true,
      voided: true
    })
      .then(({ data }) => {
        this.pageRegisterCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterCard) => {
    this.searchRegisterCard = {
      ...this.searchRegisterCard,
      ...searchRegisterCard,
    };
    this.pagingRegisterCard();
  };

  setSelectCardSync = (list) => {
    this.selectCardSync = list;
  };
  
  removeListCardToCrm = async () => {
    const cardIds = this.selectCardSync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;
    return await removeCard(cardIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCardSync = [];
        if (Array.isArray(data)) {
          const successCount = data.length;
          const total = cardIds.length;
          if (successCount === total) {
            toast.success(`Đồng bộ thẻ thành công: ${successCount}/${total} bản ghi`);
          } else if (successCount > 0) {
            toast.warning(`Đồng bộ thẻ thành công một phần: ${successCount}/${total} bản ghi`);
          } else {
            toast.error("Đồng bộ thẻ thất bại");
          }
          this.pagingRegisterCard();
          return data;
        } else {
          toast.error("Dữ liệu trả về từ API không hợp lệ");
          return [];
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCardSync = [];
        console.error(error);
        toast.error("Đồng bộ thẻ có lỗi");
        return [];
      });
  };

  resetStore = () => {
    this.searchRegisterCard = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageRegisterCard = new PageResponse();
    this.selectCardSync = [];
  };
}
